import { baseApiSlice } from '../../commons/base-api.config';
import { HTTP_METHODS } from '../../constants/http';
import { API_QUERY_UNSPLASH, API_DOWNLOAD_UNSPLASH } from '../../constants/api';
import { IQueryUnsplashParams, IQueryUnsplashResponse } from '../../interfaces/unsplash.interface';

export const unsplashApiSlice = baseApiSlice.injectEndpoints({
    endpoints(builder) {
        return {
            queryUnsplash: builder.query<IQueryUnsplashResponse, IQueryUnsplashParams>({
                query(params) {
                    return {
                        url: `${API_QUERY_UNSPLASH}/?query=${params.query}&page=${params.page}&per_page=${params.per_page}`,
                        method: HTTP_METHODS.GET,
                    };
                },
                transformResponse: ({ data }: any) => data,
                transformErrorResponse: (response) => response,
            }),
            downloadUnsplash: builder.query<any, string>({
                query(id) {
                    return {
                        url: `${API_DOWNLOAD_UNSPLASH}/${id}`,
                        method: HTTP_METHODS.GET,
                    };
                },
                transformResponse: ({ data }: any) => data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
        };
    },
});

export const { useLazyQueryUnsplashQuery, useLazyDownloadUnsplashQuery } = unsplashApiSlice;
